import { IRootState } from '../../../store'
import { IZollSupportTicketState } from '../store/zollSupportTicket.types'

export const getZollSupportTicketState = (state: IRootState): IZollSupportTicketState => state.zollSupportTicket
